/* eslint-disable arrow-body-style */

import React from "react";

// Custom
import modelIzlet from "@/models/izlet";
import modelIzletVodicSudionik from "@/models/izlet_vodic_sudionik";
import DataCentricPage from "@/views/DataCentric/DataCentricPage";
import HPSIzletForm from "./Forms/HPSIzletForm";
import { Permissions } from "@/lib/permissions";

const SPVIzletiPage = () => {

  return (
    <DataCentricPage
      needPermission={[Permissions.HPSStanicaPlanVodicaView, Permissions.Administration]}

      primaryModel={modelIzlet}
      primaryTitleToken="titles.izleti_spv"
      primaryView="spv"
      primaryAllowAdd={false}
      primaryAllowView
      primaryDialogForm="spv"
      primaryDialogComponent={HPSIzletForm}
      primaryAllowEdit={false}
      primaryAllowGeneratePDF
      primaryAllowShareIzlet={false}
      primaryAllowGenerateVodickiObrazac={false}
      primaryOverrideAPIUrl="hps/izleti?type=spv"
      primaryExportLabel="buttons.export_xlsx_izleti"
      primaryAllowApprove
      primaryAllowToggleJavno
      primaryIzletiAdminFlagChangeType="spv"

      secondaryModel={modelIzletVodicSudionik}
      secondaryTitleToken="titles.vodici_sudionici"
      secondaryView="spv"
      secondaryAllowView={false}
      
      baseRecordPath={modelIzlet.apiPath}
      childRecordRelativePath="vodici-i-sudionici"
      geomRelativePath="geom"
      miniMapBaseRecordQueryParams="?type=spv"
      
      mapId={10}
      mapModel={modelIzlet}
    />
  );
};

export default SPVIzletiPage;
